import React, { useState } from 'react';
import { IconClose, IconSpinner, IconArchive } from '../../components';
import { FormattedMessage } from '../../util/reactIntl';
import noImageIcon from './images/noImageIcon.svg';

import css from './Files.module.css';

// !!!!!!!!
const REACT_APP_DO_MAIN_URL =
  process.env.REACT_APP_DO_MAIN_URL || 'https://athlens-stage.nyc3.digitaloceanspaces.com';

const formatFileSize = size => {
  if (size < 1000) {
    return `${size} B`;
  } else if (size < 1000000) {
    return `${(size / 1000).toFixed(2)} KB`;
  } else if (size < 1000000000) {
    return `${(size / 1000000).toFixed(2)} MB`;
  } else {
    return `${(size / 1000000000).toFixed(2)} GB`;
  }
};

const Files = props => {
  const {
    files,
    transaction,
    isProvider,
    onDeleteFileTx,
    deleteFileInProgress,
    showDeleteFileButton,
    isUploadDecline,
    isCaptured,
    entity,
    id
  } = props;

  const [deleteButtonKey, setDeleteButtonKey] = useState(null);

  if (!files || !files.length) return null;

  const canDelete = entity !== 'checkoutPage' && entity !== 'txPage';
  const customer = transaction?.customer;
  const provider = transaction?.provider;
  const customerName = customer?.attributes?.profile?.displayName;
  const providerName = provider?.attributes?.profile?.displayName;

  const { providers, customers } = files.reduce(
    ({ providers, customers }, file) => {
      if (file.userRole === 'provider') {
        return { providers: [...providers, file], customers };
      } else if (file.userRole === 'customer') {
        return { providers, customers: [...customers, file] };
      }
      return { providers, customers };
    },
    { providers: [], customers: [] }
  );


  const onDelete = (e, fileKey, txId, entity) => {
    e.stopPropagation();

    if (deleteFileInProgress) return;

    setDeleteButtonKey(fileKey);
    onDeleteFileTx(fileKey, txId, entity, 'files');
  };

  const content = isProvider ? (
    <div className={css.wrapper}>
      {!!providers.length && (
        <>
          <div className={css.title}>
            <FormattedMessage id="FilesComponent.yourFilesTitle" />
          </div>
          <div className={css.root}>
            {providers.map((props, index) => {
              const { key, format, originalname, size } = props;
              const isImage =
                format === 'jpg' ||
                format === 'jpeg' ||
                format === 'png' ||
                format === 'gif' ||
                format === 'webp';
              const url = isImage ? `${REACT_APP_DO_MAIN_URL}/${key}` : noImageIcon;
              const externalUrl = `${REACT_APP_DO_MAIN_URL}/${key}`;

              return (
                <div className={css.file} key={index}>
                  {isImage ? (
                    <div
                      key={key}
                      className={css.fileImage}
                      style={{ background: `url(${url}) center/cover no-repeat` }}
                      onClick={() => window.open(externalUrl, '_blank')}
                      title={`Download ${originalname}`}
                    ></div>
                  ) : (
                    <div
                      className={css.fileImage}
                      onClick={() => window.open(externalUrl, '_blank')}
                      title={`Download ${originalname}`}
                    >
                      <IconArchive />
                    </div>
                  )}

                  <div className={css.fileInfo}>
                    <span className={css.fileTitle}>{originalname}</span>
                    <span className={css.fileSize}>{formatFileSize(size)}</span>
                  </div>

                  {canDelete &&
                    <div className={css.closeButton} onClick={e => onDelete(e, key, id, entity)}>
                      {deleteFileInProgress && deleteButtonKey === key ? (
                        <IconSpinner rootClassName={css.spinner} />
                      ) : (
                        <IconClose rootClassName={css.closeButtonRoot} />
                      )}
                    </div>
                  }
                </div>
              );
            })}
          </div>
        </>
      )}
      {!!customers.length && (
        <>
          <div className={css.title}>
            <FormattedMessage id="FilesComponent.customerFilesTitle" values={{ customerName }} />
          </div>
          <div className={css.root}>
            {customers.map((props, index) => {
              const { key, format, originalname, size } = props;
              const isImage =
                format === 'jpg' ||
                format === 'jpeg' ||
                format === 'png' ||
                format === 'gif' ||
                format === 'webp';
              const url = isImage ? `${REACT_APP_DO_MAIN_URL}/${key}` : noImageIcon;
              const externalUrl = `${REACT_APP_DO_MAIN_URL}/${key}`;

              return (
                <div className={css.file}>
                  <div
                    key={key}
                    className={css.fileImage}
                    style={{ background: `url(${url}) center/cover no-repeat` }}
                    onClick={() => window.open(externalUrl, '_blank')}
                  ></div>
                  <div className={css.fileInfo}>
                    <span className={css.fileTitle}>{originalname}</span>
                    <span className={css.fileSize}>{formatFileSize(size)}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  ) : (
    <div className={css.wrapper}>
      {!!customers.length && (
        <>
          <div className={css.title}>
            <FormattedMessage id="FilesComponent.yourFilesTitle" />
          </div>
          <div className={css.root}>
            {customers.map((props, index) => {
              const { key, format, originalname, size } = props;
              const isImage =
                format === 'jpg' ||
                format === 'jpeg' ||
                format === 'png' ||
                format === 'gif' ||
                format === 'webp';
              const url = isImage ? `${REACT_APP_DO_MAIN_URL}/${key}` : noImageIcon;
              const externalUrl = `${REACT_APP_DO_MAIN_URL}/${key}`;
              return (
                <div className={css.file} key={index}>
                  {isImage ? (
                    <div
                      key={key}
                      className={css.fileImage}
                      style={{ background: `url(${url}) center/cover no-repeat` }}
                      onClick={() => window.open(externalUrl, '_blank')}
                      title={`Download ${originalname}`}
                    ></div>
                  ) : (
                    <div
                      className={css.fileImage}
                      onClick={() => window.open(externalUrl, '_blank')}
                      title={`Download ${originalname}`}
                    >
                      <IconArchive />
                    </div>
                  )}

                  <div className={css.fileInfo}>
                    <span className={css.fileTitle}>{originalname}</span>
                    <span className={css.fileSize}>{formatFileSize(size)}</span>
                  </div>

                  {canDelete &&
                    <div className={css.closeButton} onClick={e => onDelete(e, key, id, entity)}>
                      {deleteFileInProgress && deleteButtonKey === key ? (
                        <IconSpinner rootClassName={css.spinner} />
                      ) : (
                        <IconClose rootClassName={css.closeButtonRoot} />
                      )}
                    </div>
                  }
                </div>
              );
            })}
          </div>
        </>
      )}
      {!!providers.length && (
        <>
          <div className={css.title}>
            <FormattedMessage id="FilesComponent.providerFilesTitle" values={{ providerName }} />
          </div>
          <div className={css.root}>
            {providers.map((props, index) => {
              const { key, format, originalname, size } = props;
              const isImage =
                format === 'jpg' ||
                format === 'jpeg' ||
                format === 'png' ||
                format === 'gif' ||
                format === 'webp';
              const url = isImage ? `${REACT_APP_DO_MAIN_URL}/${key}` : noImageIcon;
              const externalUrl = `${REACT_APP_DO_MAIN_URL}/${key}`;

              return (
                <div className={css.file}>
                  <div
                    key={key}
                    className={css.fileImage}
                    style={{ background: `url(${url}) center/cover no-repeat` }}
                    onClick={() => window.open(externalUrl, '_blank')}
                  ></div>
                  <div className={css.fileInfo}>
                    <span className={css.fileTitle}>{originalname}</span>
                    <span className={css.fileSize}>{formatFileSize(size)}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );


  return (
    <div className={css.root}>
      <div className={css.root}>
        {content}
      </div>
    </div>
  );
};

export default Files;
